// The design's Surface/disabled and Text/disabled, for a control or box that reads as disabled
export const DISABLED_INPUT_CLASS =
  "disabled:!opacity-100 disabled:border-transparent disabled:bg-slate-200 disabled:text-slate-400";

export const DISABLED_SELECT_CLASS =
  "disabled:!opacity-100 disabled:border-slate-300 disabled:bg-slate-200 disabled:text-slate-400";

/** A static read-only box that reads as a disabled field but is not a control. */
export const DISABLED_BOX_CLASS =
  "flex h-8 items-center overflow-hidden rounded-lg border border-slate-300 bg-slate-200 px-2 text-sm text-slate-400";
